import { render, staticRenderFns } from "./dentists.vue?vue&type=template&id=ed8a83c0"
import script from "./dentists.vue?vue&type=script&lang=js"
export * from "./dentists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports